import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { getFormValues, change } from 'redux-form';

import { CEPBulkProcessingForm } from './components/CEPBulkProcessingForm';
import { CEP_BULK_PROCESSING_FORM_NAME } from 'Common/FormEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { Filter, Main } from 'Containers/';
import { LoadingPage, TitledCard } from 'Components/';
import { CEPBulkProcessingFieldEnum as Fields } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants/dateformat';

import {
  getReimbursableItems,
  getMealValues,
  writeMealValues,
  getSitesByFiscalYear,
  clearError,
  clearWasWritten,
  setIsISPNull,
  getFiscalYears,
  getIsDayClosedAction,
} from './state/processing/actions';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { buildMessage } from './helpers/MessageBuilder';
import {
  shouldMealValueUpdate,
  getReimbursableItem,
} from './helpers/GenericHelpers';
import { PopUpMessage } from './components/PopUpMessage';
import { createToast, toastError, toastType } from 'Common/ToastHelper';
import { DATE_FORMAT_FOR_DB_STRING } from 'Common/Constants';

class CEPBulkProcessingContainer extends Component {
  state = {
    displayDialog: false,
    message: '',
    sitesErrorShown: false,
    selectedFiscalYear: null,
    hasSiteBeenToasted: false,
    hasDayBeenToasted: false,
  };

  getMainProps = () => {
    const { loading, isDayClosed } = this.props;
    return {
      toolbox: {
        formName: CEP_BULK_PROCESSING_FORM_NAME,
        saveButtonProps: {
          content: 'Submit',
          loading,
          disabled: loading || this.shouldFormLock() || isDayClosed,
        },
        shown: true,
      },
    };
  };

  handleSubmit = () => {
    this.setState({
      message: buildMessage(
        { ...this.props.formValues, siteStudents: this.props.siteStudents },
        this.props.sites
      ),
      displayDialog: true,
    });
  };

  calculateFiscalYear = (
    servingDate,
    currentFiscalYear,
    previousFiscalYear
  ) => {
    if (moment(servingDate).isBefore(moment(`07/01/${previousFiscalYear}`))) {
      return previousFiscalYear;
    } else {
      return currentFiscalYear;
    }
  };

  componentDidMount() {
    this.props.getFiscalYears();
  }

  handleMealTypeChange = e => {
    const { getReimbursableItems } = this.props;
    getReimbursableItems(e, this.getSiteValue());
  };

  handleDialogConfirm = () => {
    const {
      writeMealValues,
      formValues,
      currentFiscalYear,
      previousFiscalYear,
      isBulk,
      hasBeenProcessed,
    } = this.props;
    this.setState({ displayDialog: false });
    const model = {
      ...formValues,
      FiscalYear: this.calculateFiscalYear(
        formValues.ServingDate,
        currentFiscalYear,
        previousFiscalYear
      ),
      hasBeenProcessed,
      isBulk,
    };
    const cutOffYear = previousFiscalYear - 1;
    const servingDate = moment(
      formValues[Fields.ServingDate],
      DATE_FORMAT_FOR_UI,
      true
    );
    if (servingDate.isValid() && servingDate.isBefore(`07/01/${cutOffYear}`)) {
      toastError(`Date must not be before 7/1/${cutOffYear}`);
      return;
    }
    writeMealValues(model);
  };

  handleDialogClose = () => {
    this.setState({ displayDialog: false });
  };

  HandleSitePercentage = () => {
    if (this.isSiteBad() && !this.state.hasSiteBeenToasted) {
      this.setState({
        hasSiteBeenToasted: true,
      });
      createToast(
        toastType.error,
        'Error',
        'Please visit the CEP Setup page and assign an ISP to ' +
          'this site and Fiscal Year before continuing',
        true,
        9000
      );
    }
  };

  isSiteBad() {
    return this.props.badSites.find(
      x => x.SiteId === this.props.formValues[Fields.Site]
    );
  }

  shouldFormLock() {
    return this.isSiteBad() || this.props.isISPNull ? true : false;
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      wasWritten,
      error,
      clearError,
      getMealValues,
      clearWasWritten,
      formValues,
      hasBeenProcessed,
      reimbursableItems,
      reimbursableItem,
      sites,
      sitesLoaded,
      badSites,
      previousFiscalYear,
      currentFiscalYear,
      getReimbursableItems,
      isDayClosed,
      isDayClosedLoading,
    } = this.props;

    let selectedFiscalYear = this.calculateFiscalYear(
      formValues.ServingDate,
      currentFiscalYear,
      previousFiscalYear
    );

    let selectedSite = this.getSiteValue();

    // if the values have changed in the form and formValues existed
    // in the last component update
    if (formValues && prevProps.formValues) {
      const { ServingDate, TotalParticipation, MealType } = formValues;
      if (shouldMealValueUpdate(prevProps, this.props)) {
        if (this.state.selectedFiscalYear !== selectedFiscalYear) {
          this.setState({
            selectedFiscalYear: selectedFiscalYear,
          });
        }
        if (prevState.FiscalYear !== selectedFiscalYear) {
          this.props.getSitesByFiscalYear(selectedFiscalYear);
        }

        const totalParticipationParsed = parseInt(TotalParticipation, 10);
        let totalParticipationValue = isNaN(totalParticipationParsed)
          ? 0
          : totalParticipationParsed;

        const model = {
          Site: selectedSite,
          TotalParticipation: totalParticipationValue,
          ServingDate,
          MealType,
          FiscalYear: selectedFiscalYear,
        };
        getMealValues(model);
      }

      // if the values result in hasBeenProcessed being true,
      // and the totalParticipation prop calculated from adding the free
      // and paid meals has changed, set the value of totalParticipation
      // in the form to the props value.
      if (
        hasBeenProcessed &&
        (this.props.totalParticipation !== prevProps.totalParticipation ||
          shouldMealValueUpdate(prevProps, this.props))
      ) {
        this.props.change(
          CEP_BULK_PROCESSING_FORM_NAME,
          Fields.TotalParticipation,
          this.props.totalParticipation
        );
      }

      if (prevProps.hasBeenProcessed && !hasBeenProcessed) {
        this.props.change(
          CEP_BULK_PROCESSING_FORM_NAME,
          Fields.TotalParticipation,
          0
        );
      }

      // if the meal values have just been marked processed,
      // or the reimbursable items have changed,
      // or the reimbursable item has changed,
      // set the reimbursable item
      if (
        (hasBeenProcessed &&
          !prevProps.hasBeenProcessed === hasBeenProcessed) ||
        reimbursableItems !== prevProps.reimbursableItems ||
        reimbursableItem !== prevProps.reimbursableItem
      ) {
        this.props.change(
          CEP_BULK_PROCESSING_FORM_NAME,
          Fields.ReimbursableItem,
          getReimbursableItem(reimbursableItem, reimbursableItems)
        );
      }

      // if the site changes, reset the toasted flag amd toast if its a bad site
      if (formValues[Fields.Site] !== prevProps.formValues[Fields.Site]) {
        this.setState({
          hasSiteBeenToasted: false,
        });
        this.HandleSitePercentage();

        if (formValues[Fields.MealType] !== null) {
          getReimbursableItems(
            formValues[Fields.MealType],
            formValues[Fields.Site]
          );
        }
      }

      // If the Date or Site changes, format the serving date for the DB,
      // Check the back end to see if the day is closed.
      // Set closed status in reducer.
      // If closed, alert the user with a toast.
      if (
        ServingDate !== prevProps.formValues[Fields.ServingDate] ||
        formValues[Fields.Site] !== prevProps.formValues[Fields.Site]
      ) {
        const { primarySites, formValues } = this.props;
        const { ServingDate } = formValues;
        let selectedSite = this.getSiteValue();
        const formattedDate = moment(ServingDate).format(
          DATE_FORMAT_FOR_DB_STRING
        );
        this.props.getIsDayClosedAction({
          PrimarySiteId: primarySites[selectedSite],
          ClosingDate: formattedDate,
        });
        this.setState({
          hasDayBeenToasted: false,
        });
      }
      if (!this.state.hasDayBeenToasted && isDayClosed && !isDayClosedLoading) {
        toastError(
          'The day for the selected site and date is currently closed. ' +
            'CEP counts cannot be updated unless the day is open.'
        );
        this.setState({
          hasDayBeenToasted: true,
        });
      }

      // If the serving date changes
      if (
        formValues[Fields.ServingDate] !==
        prevProps.formValues[Fields.ServingDate]
      ) {
        // If the Serving Date is outside of the current or previous fiscal year,
        // throw an error.
        const cutOffYear = previousFiscalYear - 1;
        const servingDate = moment(
          formValues[Fields.ServingDate],
          DATE_FORMAT_FOR_UI,
          true
        );
        if (
          servingDate.isValid() &&
          servingDate.isBefore(`07/01/${cutOffYear}`)
        ) {
          toastError(`Date must not be before 7/1/${cutOffYear}`);
        }

        // If the fiscal year of the Serving Date changes, re fetch the sites list
        // and reset hasSiteBeenToasted
        if (
          selectedFiscalYear !==
          this.calculateFiscalYear(
            prevProps.formValues.ServingDate,
            currentFiscalYear,
            previousFiscalYear
          )
        ) {
          this.props.getSitesByFiscalYear(selectedFiscalYear);
          this.setState({
            hasSiteBeenToasted: false,
          });
          // Ensure that if the site has not changed, but the fiscal year has, the site does not have a null ISP
          this.HandleSitePercentage();
        }
      }

      // If currentFiscalYear was previously null, and is no longer null
      // fetch the site list by fiscal year.
      if (prevProps.currentFiscalYear === null && currentFiscalYear !== null) {
        this.props.getSitesByFiscalYear(this.props.currentFiscalYear);
      }
    }

    // if an error exists, toast it, then clear the error
    if (error) {
      toastError(error);
      clearError();
    }

    //if the sites endpoint has been hit and no sites were found, display an error
    if (!sites.length > 0 && !this.state.sitesErrorShown && sitesLoaded) {
      toastError('Sites not found.');
      this.setState({
        sitesErrorShown: true,
      });
    }

    // if the Values were written to the DB successfully, notify the user, then clear wasWritten
    if (wasWritten) {
      createToast(
        toastType.success,
        'Success',
        'CEP Meal Values Processed',
        true
      );
      clearWasWritten();
    }

    // when the component loads the list of bad sites, check to ensure
    // the default site is not a bad site.
    if (
      (!prevProps.badSites || prevProps.badSites !== badSites) &&
      badSites.length > 0
    ) {
      this.HandleSitePercentage();
    }
  }

  getSiteValue() {
    const { formValues, sites } = this.props;
    if (formValues && formValues[Fields.Site] && this.sitesArrayHasSite()) {
      return formValues[Fields.Site];
    } else {
      return sites.length > 0 ? sites[0].value : null;
    }
  }

  sitesArrayHasSite() {
    const { sites, formValues } = this.props;
    let foundSite = sites.find(function(site) {
      return site.value.toString() === formValues[Fields.Site];
    });
    return foundSite;
  }

  render() {
    const {
      loading,
      reimbursableItems,
      formValues,
      freeMeals,
      paidMeals,
      sites,
      loadingReimbursableItems,
      hasBeenProcessed,
      badSites,
      currentFiscalYear,
      loadingTotalParticipation,
    } = this.props;
    return (
      <Fragment>
        {loading ? <LoadingPage /> : undefined}
        <YesNoDialog
          title={'Community Eligibility Provision'}
          question={<PopUpMessage messages={this.state.message} />}
          showDialog={this.state.displayDialog}
          yesCallback={this.handleDialogConfirm}
          noCallback={this.handleDialogClose}
          yesText={'Process'}
          noText={'Cancel'}
        />
        <Filter title={'Community Eligibility Provision'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Options'}>
            <CEPBulkProcessingForm
              sites={sites}
              onSubmit={this.handleSubmit}
              reimbursableItems={reimbursableItems}
              mealTypeOnChange={this.handleMealTypeChange}
              loadingReimbursableItems={loadingReimbursableItems}
              hasBeenProcessed={hasBeenProcessed}
              currentFiscalYear={currentFiscalYear}
              shouldFormLock={this.shouldFormLock()}
              loadingTotalParticipation={loadingTotalParticipation}
              badSites={badSites}
              initialValues={{
                [Fields.ServingDate]: formValues
                  ? formValues[Fields.ServingDate]
                  : defaultDateFormat(moment()),
                [Fields.MealType]: formValues
                  ? formValues[Fields.MealType]
                  : null,
                [Fields.Site]: this.getSiteValue(),
                [Fields.FreeMeals]: freeMeals,
                [Fields.PaidMeals]: paidMeals,
                [Fields.TotalParticipation]: formValues
                  ? formValues[Fields.TotalParticipation]
                  : null,
                [Fields.ReimbursableItem]: formValues
                  ? formValues[Fields.ReimbursableItem]
                  : null,
              }}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { processing } = state.CEPBulkProcessingState;
  return {
    reimbursableItems: processing.reimbursableItems,
    formValues: getFormValues(CEP_BULK_PROCESSING_FORM_NAME)(state),
    freeMeals: processing.freeMeals,
    paidMeals: processing.paidMeals,
    loading: processing.loading,
    sites: processing.sites,
    error: processing.error,
    wasWritten: processing.wasWritten,
    loadingReimbursableItems: processing.loadingReimbursableItems,
    hasBeenProcessed: processing.hasBeenProcessed,
    reimbursableItem: processing.reimbursableItem,
    siteStudents: processing.siteStudents,
    totalParticipation: processing.totalParticipation,
    sitesLoaded: processing.sitesLoaded,
    isISPNull: processing.isISPNull,
    badSites: processing.badSites,
    previousFiscalYear: processing.previousFiscalYear,
    currentFiscalYear: processing.currentFiscalYear,
    sitesLoading: processing.sitesLoading,
    isBulk: processing.isBulk,
    loadingTotalParticipation: processing.loadingTotalParticipation,
    isDayClosed: processing.isDayClosed,
    primarySites: processing.primarySites,
    isDayClosedLoading: processing.isDayClosedLoading,
  };
};

const mapDispatchToProps = {
  getMealValues,
  getReimbursableItems,
  writeMealValues,
  getSitesByFiscalYear,
  clearError,
  clearWasWritten,
  setIsISPNull,
  change,
  getFiscalYears,
  getIsDayClosedAction,
};

export const CEPBulkProcessing = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CEPBulkProcessingContainer)
);



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/CEPBulkProcessing.js